module.exports = __webpack_public_path__ + "fonts/8771894.ttf";